import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Card, Table, TableHead, TableBody, TableRow, TableCell,
  TableContainer, TablePagination, Select, MenuItem, FormControl, InputLabel, Chip
} from '@mui/material';
import { auditAPI } from '../../services/api';
import dayjs from 'dayjs';

export default function AuditLog() {
  const [entries, setEntries] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [entityType, setEntityType] = useState('');

  useEffect(() => {
    auditAPI.list({ page: page + 1, per_page: 25, entity_type: entityType || undefined })
      .then((r) => { setEntries(r.data.data); setTotal(r.data.total); });
  }, [page, entityType]);

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">Audit Log</Typography>
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Entity Type</InputLabel>
          <Select value={entityType} label="Entity Type" onChange={(e) => { setEntityType(e.target.value); setPage(0); }}>
            <MenuItem value="">All</MenuItem>
            {['user', 'form', 'application', 'review', 'review_criteria', 'scholarship_decision',
              'reviewer_assignment', 'email_template', 'smtp_config', 'registration'].map((t) => (
              <MenuItem key={t} value={t}>{t.replace('_', ' ')}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Card>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Entity</TableCell>
                <TableCell>IP</TableCell>
                <TableCell>Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.map((e) => (
                <TableRow key={e.id}>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{dayjs(e.created_at).format('MMM D HH:mm:ss')}</TableCell>
                  <TableCell>{e.user_email || '—'}</TableCell>
                  <TableCell><Chip label={e.action} size="small" variant="outlined" /></TableCell>
                  <TableCell>{e.entity_type}{e.entity_id ? ` (${e.entity_id.slice(0, 8)}…)` : ''}</TableCell>
                  <TableCell>{e.ip_address}</TableCell>
                  <TableCell sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {e.new_values ? JSON.stringify(e.new_values).slice(0, 80) : '—'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination component="div" count={total} page={page} onPageChange={(_, p) => setPage(p)}
          rowsPerPage={25} rowsPerPageOptions={[25]} />
      </Card>
    </Box>
  );
}
